import {
    GET_CURRENT_TYPE
} from './constants';

const initialState = {
    currentType: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_TYPE: {
            return {
                ...state,
                currentType: action.payload,
            };
        }
        default:
            return state;
    }
};

